import { cn } from '@/lib/cn';
import { Link } from '@tanstack/react-router';
import { Card, CardDescription, CardHeader, CardTitle } from './DashboardCard';

export interface DashboardLinkIconCardProps {
  Icon: React.ElementType;
  title: string;
  description: string;
  notificationCount?: number;
  to: string;
  limitDescriptionLength?: boolean;
}

export const DashboardLinkIconCard = ({
  Icon,
  title,
  description,
  notificationCount,
  to,
  limitDescriptionLength = false,
}: DashboardLinkIconCardProps) => {
  return (
    <Card asChild enableHover>
      <Link to={to}>
        <CardHeader className="grid grid-cols-[auto_1fr] items-center gap-x-2.5 gap-y-1.5">
          <Icon className="text-primary size-12" />

          <CardTitle>
            <span>{title}</span>
            {!!notificationCount && (
              <span className="bg-accent text-accent-foreground flex size-9.5 items-center justify-center rounded-full text-lg leading-6">
                {notificationCount}
              </span>
            )}
          </CardTitle>

          <CardDescription
            className={cn('col-span-2', limitDescriptionLength && 'max-w-90')}
          >
            {description}
          </CardDescription>
        </CardHeader>
      </Link>
    </Card>
  );
};
